'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CollectInfoForm = _baseForm2['default'].createFormClass({

    displayName: 'CollectInfoForm',

    propTypes: {
        'tabOffset': _react2['default'].PropTypes.number,
        'emailAddress': _react2['default'].PropTypes.string,
        'fields': _react2['default'].PropTypes.array,
        'values': _react2['default'].PropTypes.object
    },

    getInitialState: function getInitialState() {
        return {
            emailAddress: this.props.emailAddress,
            fieldMap: this.mapFieldsToNames()
        };
    },


    // Creates a named map of field names so you can find by name, instead of just array index
    mapFieldsToNames: function mapFieldsToNames() {
        if (!this.props.fields || !this.props.fields.length) return {};

        return this.props.fields.reduce(function (map, field) {
            if (field.type !== 'inputhidden') {
                map[field.name] = field;
            }
            return map;
        }, {});
    },
    isRequired: function isRequired(field) {
        var classAttribute = field.attributes.className || field.attributes['class'] || '';
        return classAttribute.indexOf('required') >= 0;
    },
    fieldnameHasErrors: function fieldnameHasErrors(fieldname) {
        return this.state.hasErrors && fieldname in this.state.errors.named;
    },
    renderErrorsForFieldname: function renderErrorsForFieldname(fieldname) {
        var errors = void 0;

        if (this.fieldnameHasErrors(fieldname)) {
            errors = _react2['default'].createElement(
                'div',
                { className: 'error' },
                _react2['default'].createElement(
                    'p',
                    null,
                    'This field is required'
                )
            );
        }

        return errors;
    },
    trackNumberFilledFields: function trackNumberFilledFields() {
        var nodes = document.querySelectorAll('input[type="text"], select');
        var filled = 0;
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].value && nodes[i].value !== '0') {
                // 0 is a placeholder for our dropdowns
                filled++;
            }
        }
        _logger2['default'].track('CollectInfoModal.filled-' + filled);
    },
    onSubmit: function onSubmit(evt) {
        evt.preventDefault();

        // Check to make sure we filled in: First Name, Last Name, Company before submitting
        var firstNameVal = this.getDOMValueForFieldname('first_name');
        var lastNameVal = this.getDOMValueForFieldname('last_name');
        var companyNameVal = this.getDOMValueForFieldname('company_name');

        var namedErrors = {};
        // Validation
        if (!firstNameVal) {
            namedErrors['first_name'] = 'This field is required';
        }
        if (!lastNameVal) {
            namedErrors['last_name'] = 'This field is required';
        }
        if (!companyNameVal) {
            namedErrors['company_name'] = 'This field is required';
        }

        if (Object.keys(namedErrors).length) {
            this.setState({
                'errors': { 'named': namedErrors },
                'hasErrors': true
            });
            return;
        }

        this.setState({
            'errors': null,
            'hasErrors': false
        });

        this.trackNumberFilledFields();
        _logger2['default'].track('CollectInfoModal.submitted');

        this.submitAsync(function (resp) {
            if (resp.success) {
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
            }
        });
    },
    render: function render() {
        var _this = this;

        var initialTabValue = this.props.tabOffset || 0;
        var tabOffset = parseInt(initialTabValue, 10);

        var columnClasses = 'columns large-6 small-6 medium-6';
        var fullwidthClasses = 'columns large-12 medium-12 small-12';

        var fields = {};
        var fieldKeys = Object.keys(this.state.fieldMap); // Because Object.forEach is not available
        fieldKeys.map(function (key) {
            var field = _this.state.fieldMap[key];

            var options = {
                'tabIndex': field.attributes.tabindex || ++tabOffset,
                'className': _this.fieldnameHasErrors(field.name) ? 'error' : void 0,
                'defaultValue': field['default']
            };

            if (field.type === 'input') {
                options['placeholder'] = field.options.label;
                options['data-format'] = 'text';
            } else if (field.type === 'select') {
                options['data-format'] = 'select';
            }

            var asterisk = void 0;
            if (_this.isRequired(field)) {
                asterisk = _react2['default'].createElement(
                    'span',
                    { className: 'asterisk' },
                    '*'
                );
            }

            // Currently one place where we want to use a fullwidth field; the rest are half
            var clazz = field.name === 'use_case' ? fullwidthClasses : columnClasses;
            fields[key] = _react2['default'].createElement(
                'div',
                { className: clazz },
                _react2['default'].createElement(
                    'label',
                    null,
                    field.options.label,
                    asterisk
                ),
                _this.renderField(field.name, options),
                _this.renderErrorsForFieldname(field.name)
            );
        });

        var ctaBar = _react2['default'].createElement(
            'div',
            { className: 'cta-bar' },
            _react2['default'].createElement(_button2['default'], { buttonText: 'Done', buttonTabIndex: 10, onClick: this.onSubmit, buttonColor: 'grasshopper' })
        );

        return _react2['default'].createElement(
            'form',
            { className: 'm-collect-info-form' },
            _react2['default'].createElement(
                'div',
                { className: 'm-collect-info-form--field-container' },
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    fields.first_name,
                    fields.last_name
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    fields.job_title,
                    fields.department
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    fields.company_name,
                    fields.industry
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    fields.use_case
                ),
                this.renderHiddenFields()
            ),
            ctaBar
        );
    }
});

exports['default'] = CollectInfoForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/collect-info/collect-info-form.jsx
 ** module id = 1190
 ** module chunks = 0 1
 **/